// Parts of the panel that later phases build. They open, say so plainly, and change nothing.
import { L } from '../lib/prefs';
import { Card, Empty, PageHead } from '../ui/kit';
import { toast } from '../ui/toast';
import { navItem } from './nav';

export const soon = (what: string) => toast(L(what + ' comes in a later update.', what + ' في تحديث قادم.'), { icon: 'info' });

const EXTRA: Record<string, [string, string]> = { account: ['My account', 'حسابي'], help: ['Help & support', 'المساعدة والدعم'] };

export function SoonPage({ r }: { r: string }) {
  const n = navItem(r);
  const [en, ar] = n ? [n[2], n[3]] : EXTRA[r] || ['xReceived', 'xReceived'];
  return (
    <>
      <PageHead title={L(en, ar)} />
      <Card><Empty icon={n ? n[1] : 'info'} title={L('Coming in a later update', 'في تحديث قادم')} body={L('This page is not part of the panel yet. Everything you set up so far is saved.', 'هذه الصفحة ليست في اللوحة بعد. كل ما أعددته محفوظ.')} /></Card>
    </>
  );
}
